import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import AboutStory from './components/AboutStory';
import AboutMissionVision from './components/AboutMissionVision';
import AboutValues from './components/AboutValues';
import AboutCTA from './components/AboutCTA';
import SeoHead from '../../components/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com';

const aboutJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'About CJ Solutions Ltd',
    url: `${siteUrl}/about`,
    description: 'Learn about CJ Solutions Ltd — our story, mission, values, and the expert team behind our compliance, AML, and licensing services in Limassol, Cyprus.',
    publisher: {
      '@type': 'Organization',
      name: 'CJ Solutions Ltd',
      url: siteUrl,
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: 'About Us', item: `${siteUrl}/about` },
    ],
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="About CJ Solutions | Compliance Experts Cyprus"
        description="Discover the story, mission, and values behind CJ Solutions Ltd. A trusted compliance, AML, and licensing consultancy based in Limassol, Cyprus."
        keywords="about CJ Solutions, compliance experts Cyprus, AML consultancy Limassol, licensing specialists"
        canonical="/about"
        jsonLd={aboutJsonLd}
      />
      <Header />
      <main>
        <AboutHero />
        <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 700px'}}>
          <AboutStory />
        </div>
        <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 600px'}}>
          <AboutMissionVision />
        </div>
        <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 500px'}}>
          <AboutValues />
        </div>
        <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 400px'}}>
          <AboutCTA />
        </div>
      </main>
      <Footer />
    </div>
  );
}
